import styled from "styled-components";

export const FooterBtn = styled.button`
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  position: fixed;
  bottom: 0px;
`;
export const FooterContainer = styled.div`
  position: relative;
  margin: 1rem;
`;
